export const Urls = {
    PreventingLostTokens: 'https://docs.thetatoken.org/docs/preventing-lost-eth-erc20-tokens'
};
